import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
import { CashButton, CashDialog, CashFacts, CashNotice } from './CashPrimitives';
import { CashPeriodPicker, cashPeriodValid } from './CashPeriodPicker';
import { cashBusinessDate } from './cashBusinessDate';
import { formatCashMinor } from './cashMoney';
const copy = {
    title: ['Продажи и прибыль', 'Satışlar və mənfəət', 'Sales and profit'],
    about: ['О данных', 'Məlumat haqqında', 'About the data'],
    CURRENT_RECEIVABLES: ['Долги на сегодня', 'Bu günə borclar', 'Debts today'],
    PRIOR_PERIOD_RECEIPTS: ['Погашения до начала учёта', 'Uçot başlamazdan əvvəlki dövrün ödənişləri', 'Collections for periods before the opening checkpoint'],
    RECEIVABLE_PREVIOUS_REPORT_NET: ['Прежний отчётный нетто-остаток · справочно', 'Əvvəlki hesabatın xalis qalığı · arayış', 'Previous report net balance · reference'],
    HISTORICAL_ACCRUALS: ['Исторические начисления', 'Tarixi hesablamalar', 'Historical accruals'],
    PAID_EXPENSES: ['Оплаченные расходы', 'Ödənilmiş xərclər', 'Paid expenses'],
    UNPAID_EXPENSES: ['Неоплаченные расходы', 'Ödənilməmiş xərclər', 'Unpaid expenses'],
    confirmedWithoutTotal: [
        'Показаны подтверждённые данные без общего итога.',
        'Təsdiqlənmiş məlumatlar ümumi yekun olmadan göstərilir.',
        'Confirmed records are shown without a complete total.',
    ],
    periodReceiptsHelp: [
        'Прямые поступления от продаж и выплаты по дебиторке за месяц. Это не распределение оплаты продаж выбранного месяца.',
        'Ay ərzində birbaşa satış daxilolmaları və debitor borcu ödənişləridir. Seçilmiş ayın satış ödənişlərinin bölgüsü deyil.',
        'Direct sales receipts and receivable repayments in the month. This is not an allocation of payments to the selected month sales.',
    ],
    partialContext: ['Частичные данные', 'Qismən məlumat', 'Partial data'],
    ownerShort: ['Статья собственника', 'Sahib maddəsi', 'Owner category'],
    referenceShort: ['Подробнее', 'Ətraflı', 'Details'],
    confirmed: ['Подтверждено', 'Təsdiqlənib', 'Confirmed'],
    incompleteValue: [
        'Известная часть; итог не подтверждён',
        'Məlum hissə; yekun təsdiqlənməyib',
        'Known portion; total is not confirmed',
    ],
    REGISTERED_RESULT: ['Результат по учёту', 'Uçot üzrə nəticə', 'Recorded result'],
    UNATTRIBUTED_BRANCH: ['Филиал не указан', 'Filial göstərilməyib', 'Branch unspecified'],
    COUNTERPARTY_UNATTRIBUTED: ['Контрагент не указан', 'Kontragent göstərilməyib', 'Counterparty unspecified'],
    CATEGORY_UNATTRIBUTED: ['Статья не указана', 'Maddə göstərilməyib', 'Category unspecified'],
    UNALLOCATED_SALES_STATUS: ['Без подтверждённого статуса оплаты', 'Ödəniş statusu təsdiqlənməyib', 'Payment status unconfirmed'],
    PERIOD_CASH_RECEIPTS_REFERENCE: ['Поступления за месяц · справочно', 'Ayın daxilolmaları · arayış', 'Period receipts · reference'],
    salesReferenceNote: [
        'Первичные факты сохранены справочно. Они не прибавляются к продажам и не подтверждают оплату продаж выбранного месяца.',
        'İlkin faktlar arayış üçün saxlanılıb. Satışlara əlavə edilmir və seçilmiş ayın satış ödənişlərini təsdiqləmir.',
        'Source facts are retained for reference. They do not add to sales or confirm payment of the selected month’s sales.',
    ],
    RESULT_SALES: ['Продажи по учёту', 'Uçot üzrə satışlar', 'Recorded sales'],
    RESULT_PURCHASES: ['Минус закупки', 'Çıxılsın alışlar', 'Less purchases'],
    RESULT_EXPENSES: ['Минус расходы', 'Çıxılsın xərclər', 'Less expenses'],
    SALES_SOURCE_ADJUSTMENTS: ['Корректировки продаж по источнику', 'Mənbə üzrə satış düzəlişləri', 'Source sales adjustments'],
    SALES_RECONCILIATION_ADJUSTMENTS: ['Корректировки и удержания', 'Düzəlişlər və tutulmalar', 'Adjustments and withheld fees'],
    SALES_RECONCILIATION_GAP: ['Расхождение', 'Fərq', 'Unexplained difference'],
    RECEIVABLE_SETTLED: ['Погашено', 'Ödənilib', 'Settled'],
    cohortPaid: ['Оплачено', 'Ödənilib', 'Paid'],
    cohortDue: ['Не оплачено', 'Ödənilməyib', 'Unpaid'],
    cohortFormula: ['Продажи = оплачено + не оплачено + корректировки + расхождение', 'Satışlar = ödənilib + ödənilməyib + düzəlişlər + fərq', 'Sales = paid + unpaid + adjustments + unexplained difference'],
    cohortPaidHelp: ['Оплаты продаж выбранного месяца, включая связанные погашения дебиторки. Оплаты прошлых периодов сюда не входят.', 'Seçilmiş ayın satış ödənişləri və əlaqəli debitor ödənişləri. Əvvəlki dövrlərin ödənişləri daxil deyil.', 'Payments for the selected sales month, including linked receivable collections. Prior-period collections are excluded.'],
    COMMISSIONS: ['Комиссии', 'Komissiyalar', 'Fees'],
    EXPENSE_CASH_REFERENCE: ['Выплаты по дате денег', 'Pul tarixinə görə ödənişlər', 'Payments by cash date'],
    registeredFormula: [
        'Продажи − закупки − расходы',
        'Satışlar − alışlar − xərclər',
        'Sales − purchases − expenses',
    ],
    incompleteCalculation: ['Расчёт неполный', 'Hesablama natamamdır', 'Incomplete calculation'],
    scope: ['Область', 'Əhatə', 'Scope'],
    ownerSource: [
        'Выплаты по статье собственника',
        'Sahib maddəsi üzrə ödənişlər',
        'Payments under the owner category',
    ],
    OWNER_SOURCE_OUTFLOWS: [
        'Выплаты по статье собственника',
        'Sahib maddəsi üzrə ödənişlər',
        'Payments under the owner category',
    ],
    cashReference: [
        'Денежные выплаты · справочно',
        'Pul ödənişləri · arayış',
        'Cash payments · reference',
    ],
    cashReferenceNote: [
        'Справочные суммы не прибавляются к итогу расходов.',
        'Arayış məbləğləri xərclərin yekununa əlavə edilmir.',
        'Reference amounts are not added to expense totals.',
    ],
    procurementReferenceNote: [
        'Не прибавляется к закупкам повторно.',
        'Alışlara təkrar əlavə edilmir.',
        'Not added to purchases again.',
    ],
    PROCUREMENT_CASH_PAID: ['Оплачено поставщикам', 'Təchizatçılara ödənilib', 'Paid to suppliers'],
    CASH_TAX_PAID: ['Налоги и штрафы', 'Vergilər və cərimələr', 'Taxes and fines'],
    amountLabel: ['Сумма', 'Məbləğ', 'Amount'],
    OPERATION: ['Операция', 'Əməliyyat', 'Operation'],
    BASIS: ['Начисление / документ', 'Hesablama / sənəd', 'Accrual / document'],
    RECEIVABLE: ['Дебиторский счёт', 'Debitor hesabı', 'Receivable account'],
    SOURCE_DOCUMENT: ['Исходный документ', 'İlkin sənəd', 'Source document'],
    month: ['Месяц', 'Ay', 'Month'],
    currency: ['Валюта', 'Valyuta', 'Currency'],
    refresh: ['Обновить', 'Yenilə', 'Refresh'],
    loading: ['Загружаем данные…', 'Məlumatlar yüklənir…', 'Loading data…'],
    detailChanged: ['Данные изменились. Откройте детализацию снова.', 'Məlumatlar dəyişdi. Təfərrüatı yenidən açın.', 'The data changed. Open the details again.'],
    failed: [
        'Не удалось получить отчёт.',
        'Hesabatı yükləmək mümkün olmadı.',
        'Could not load the report.',
    ],
    selectMonth: ['Укажите полный месяц.', 'Tam ayı seçin.', 'Choose a complete month.'],
    today: ['Расчёты на сегодня', 'Bu günə hesablaşmalar', 'Settlements today'],
    asOf: ['По состоянию на', 'Tarixinə', 'As of'],
    allStores: ['Все доступные филиалы', 'Bütün əlçatan filiallar', 'All accessible branches'],
    source: ['Источник', 'Mənbə', 'Source'],
    close: ['Закрыть', 'Bağla', 'Close'],
    details: ['Детализация', 'Təfərrüatlar', 'Details'],
    noDetails: [
        'Подробности не предоставлены.',
        'Təfərrüatlar təqdim edilməyib.',
        'Details have not been provided.',
    ],
    unavailable: ['Нет данных', 'Məlumat yoxdur', 'Unavailable'],
    noAccess: ['Нет доступа', 'Giriş yoxdur', 'No access'],
    known: ['Известно', 'Məlumdur', 'Known'],
    partial: ['Полный итог неизвестен', 'Tam yekun məlum deyil', 'Full total is unknown'],
    partialBadge: [
        'Часть · итог неизвестен',
        'Hissə · tam yekun məlum deyil',
        'Partial · full total unknown',
    ],
    registered: ['Зарегистрированная часть', 'Qeydə alınmış hissə', 'Registered portion'],
    directReceipts: [
        'Прямые поступления от продаж',
        'Birbaşa satış daxilolmaları',
        'Direct sales receipts',
    ],
    notCalculated: ['Не рассчитана', 'Hesablanmayıb', 'Not calculated'],
    truncated: [
        'Список показан частично; итог не рассчитан по видимым строкам.',
        'Siyahı qismən göstərilir; yekun görünən sətirlərdən hesablanmır.',
        'The list is partial; the total is not calculated from visible rows.',
    ],
    sourceDate: ['Дата источника', 'Mənbənin tarixi', 'Source date'],
    reference: ['Идентификатор', 'İdentifikator', 'Reference'],
    sales: ['Продажи', 'Satışlar', 'Sales'],
    cogs: ['Себестоимость', 'Maya dəyəri', 'Cost of sales'],
    expenses: ['Расходы', 'Xərclər', 'Expenses'],
    profit: ['Прибыль', 'Mənfəət', 'Profit'],
    loss: ['Убыток', 'Zərər', 'Loss'],
    afterTax: ['После налогов', 'Vergilərdən sonra', 'After taxes'],
    purchasesMonth: ['Закупки за месяц', 'Ayın alışları', 'Purchases for the month'],
    owner: ['Собственник забрал', 'Sahibin götürdüyü', 'Owner withdrawals'],
    receivables: ['Нам должны', 'Bizə borcludurlar', 'Owed to us'],
    payables: ['Мы должны', 'Biz borcluyuq', 'We owe'],
    money: ['Деньги на счетах', 'Hesablardakı pul', 'Money in accounts'],
    RECEIVED: ['Деньги поступили', 'Pul daxil olub', 'Money received'],
    DUE: ['Деньги не поступили', 'Pul daxil olmayıb', 'Money not received'],
    STANDARD: ['Стандартные', 'Standart', 'Standard'],
    VARIABLE: ['Изменяющиеся', 'Dəyişən', 'Variable'],
    UNCLASSIFIED: ['Не распределено по группам', 'Qruplara bölünməyib', 'Not allocated to groups'],
    ACCRUED: [
        'Начисления',
        'Hesablamalar',
        'Accruals',
    ],
    SUPPLIERS: [
        'Поставщики',
        'Təchizatçılar',
        'Suppliers',
    ],
    REGISTERED_RECEIVABLE_SALES: [
        'Зарегистрировано в долг',
        'Qeydə alınmış nisyə satışlar',
        'Registered credit sales',
    ],
    UNALLOCATED_RECEIPTS: [
        'Поступления без связи с продажами периода',
        'Dövrün satışları ilə əlaqəsiz daxilolmalar',
        'Receipts not linked to period sales',
    ],
    FEES: ['Комиссии', 'Komissiyalar', 'Fees'],
    directHelp: [
        'Подтверждены прямые поступления. Полная разбивка по продажам периода не подтверждена; оплаты дебиторки сюда не включены.',
        'Birbaşa daxilolmalar təsdiqlənib. Dövrün satışları üzrə tam bölgü təsdiqlənməyib; debitor borclarının ödənişləri buraya daxil deyil.',
        'Direct receipts are confirmed. The full period-sales allocation is not confirmed; receivable repayments are excluded.',
    ],
    creditHelp: [
        'Первоначально зарегистрированные требования за месяц, а не остаток к получению.',
        'Ay ərzində ilkin qeydə alınmış tələblərdir, alınmalı qalıq deyil.',
        'Original claims registered in the month, rather than the remaining amount to receive.',
    ],
    expenseSubset: [
        'Показана известная часть расходов по периоду. Неоплаченные или неподтверждённые начисления могут изменить итог.',
        'Dövr üzrə xərclərin məlum hissəsi göstərilir. Ödənilməmiş və ya təsdiqlənməmiş hesablamalar yekunu dəyişə bilər.',
        'This is the known portion of expenses for the service period. Unpaid or unconfirmed accruals may change the total.',
    ],
};
export const cashOwnerDashboardText = (locale, key) => copy[key][locale === 'ru' ? 0 : locale === 'az' ? 1 : 2];
/** Flatten display groups while retaining the context of each source fact. */
export function cashOwnerFlatRows(rows, trail = []) {
    return rows.flatMap(item => {
        if (item.state === 'NO_ACCESS')
            return [{ ...item, children: [], references: undefined }];
        const group = ['STANDARD', 'VARIABLE', 'UNCLASSIFIED'].includes(item.key ?? '');
        if (group)
            return cashOwnerFlatRows(item.children, trail);
        if (item.source || !item.children.length)
            return [{ ...item, label: [...trail, item.label].filter(Boolean).join(' · ') || item.label }];
        return cashOwnerFlatRows(item.children, [...trail, ...(item.label ? [item.label] : [])]);
    });
}
const reasons = {
    KNOWN_ACCRUAL_PORTION: ['В расходы включена подтверждённая часть начисления без прежних оплат.', 'Xərclərə hesablamanın əvvəlki ödənişlərsiz təsdiqlənmiş hissəsi daxildir.', 'Expenses include the confirmed accrual portion excluding prior payments.'],
    EXPENSE_PAYMENT_STATUS_CURRENT: ['Период расхода выбран выше. Статус оплаты — на сегодня.', 'Xərc dövrü yuxarıda seçilib. Ödəniş statusu bu günədir.', 'Expenses use the selected service period. Payment status is current.'],
    SALES_MONTH_COHORT: ['Продажи и связанные оплаты относятся к выбранному месяцу. Долг рассчитан на конец этого периода; распределение по отдельным дням не выдумывается.', 'Satışlar və əlaqəli ödənişlər seçilmiş aya aiddir. Borc dövrün sonuna hesablanır; ayrı-ayrı günlərə təxmini bölgü aparılmır.', 'Sales and linked payments use the selected sales month. Debt is measured at the period end; individual sale days are not assigned guessed payments.'],
    SALES_COHORT_CONFLICT: ['Связанные погашения не согласованы с продажами месяца. Разница не закрыта автоматически.', 'Əlaqəli ödənişlər ayın satışları ilə uzlaşmır. Fərq avtomatik bağlanmayıb.', 'Linked settlements do not reconcile with monthly sales. No automatic balancing adjustment was made.'],
    SALES_PAYMENT_STATUS_UNALLOCATED: [
        'Полная связь продаж месяца с оплатами не подтверждена. Неоплаченная часть не рассчитана.',
        'Ayın satışlarının ödənişlərlə tam əlaqəsi təsdiqlənməyib. Ödənilməmiş hissə hesablanmayıb.',
        'The full link between monthly sales and payments is unconfirmed. The unpaid portion is not calculated.',
    ],
    BRANCH_ATTRIBUTION_UNAVAILABLE: ['Филиал части данных не подтверждён.', 'Bəzi məlumatların filialı təsdiqlənməyib.', 'The branch attribution of some records is unconfirmed.'],
    COUNTERPARTY_UNATTRIBUTED: ['Контрагент не указан в источнике.', 'Mənbədə kontragent göstərilməyib.', 'The source does not specify a counterparty.'],
    CATEGORY_UNATTRIBUTED: ['Статья не указана в источнике.', 'Mənbədə maddə göstərilməyib.', 'The source does not specify a category.'],
    LEGACY_PRIOR_RECEIVABLES_ZEROED: [
        'Исторические погашения Nisyə за прошлый период исключены из дебиторки по правилу владельца. Новые долги учитываются отдельно; исходные операции сохранены.',
        'Sahibin qaydasına əsasən əvvəlki dövrün Nisyə ödənişləri debitor borcundan çıxarılıb. Yeni borclar ayrıca nəzərə alınır; ilkin əməliyyatlar saxlanılır.',
        'The owner’s rule excludes historical prior-period Nisyə settlements from receivables. New debts are counted separately; original transactions are preserved.',
    ],
    PRIOR_PERIOD_RECEIPTS_SEPARATED: ['Погашения до начала учёта раскрыты отдельно и не уменьшают зарегистрированные новые требования. Полный исторический долг неизвестен.', 'Uçotdan əvvəlki dövrün ödənişləri ayrıca göstərilir və yeni qeydiyyatlı tələbləri azaltmır. Tam tarixi borc məlum deyil.', 'Pre-opening-period collections are disclosed separately and do not reduce newly registered claims. Full historical debt is unknown.'],
    RECEIVABLE_PERIOD_EVIDENCE_UNAVAILABLE: ['Месяц или доступность части исторических погашений не подтверждены. Общий долг не рассчитан.', 'Bəzi tarixi ödənişlərin ayı və ya əlçatanlığı təsdiqlənməyib. Ümumi borc hesablanmayıb.', 'The period or readability of some historical collections is unconfirmed. The total debt is unavailable.'],
    EXPENSES_BY_SERVICE_PERIOD: [
        'Расходы отнесены к учётному периоду из начисления или подтверждённого источника. Дата выплаты сама по себе не определяет период расхода.',
        'Xərclər hesablamanın və ya təsdiqlənmiş mənbənin uçot dövrünə aiddir. Ödəniş tarixi xərc dövrünü təkbaşına müəyyən etmir.',
        'Expenses use the accrual or verified source service period. A payment date alone does not determine the expense period.',
    ],
    EXPENSE_COMPLETENESS_UNKNOWN: [
        'Полнота начислений периода пока не подтверждена.',
        'Dövrün hesablamalarının tamlığı hələ təsdiqlənməyib.',
        'The completeness of period accruals has not been confirmed.',
    ],
    PAYMENT_ONLY_PARTIAL: [
        'Для этой суммы подтверждена выплата и её период. Полное начисление может быть больше.',
        'Bu məbləğ üçün ödəniş və dövr təsdiqlənib. Tam hesablanmış məbləğ daha böyük ola bilər.',
        'The payment and its service period are known; the full accrued expense may be higher.',
    ],
    PAID_SERVICE_BEFORE_LEDGER: [
        'Расход подтверждён источником. Оплата была до начала учёта денег в программе.',
        'Xərc mənbə ilə təsdiqlənib. Ödəniş proqramda pul uçotunun başlanmasından əvvəl olub.',
        'The source confirms this expense; payment preceded the recorded cash ledger.',
    ],
    ORIGINAL_ACCRUAL_OVERLAP_UNRESOLVED: [
        'Связь части начислений с оплатами требует проверки.',
        'Bəzi hesablamaların ödənişlərlə əlaqəsi yoxlanmalıdır.',
        'Some accruals need their payment links checked.',
    ],
    SOURCE_CLASSIFICATION_REVIEW: [
        'Учтена группа исходного документа. Противоречие со статьёй раскрыто в источнике и требует проверки.',
        'İlkin sənədin qrupu nəzərə alınıb. Maddə ilə ziddiyyət mənbədə göstərilib və yoxlanmalıdır.',
        'The source document group is used. Its conflicting category is disclosed and requires review.',
    ],
    SOURCE_PERIOD_UNKNOWN: [
        'Период части выплат не подтверждён; они не добавлены к известным расходам периода.',
        'Bəzi ödənişlərin dövrü təsdiqlənməyib; onlar dövrün məlum xərclərinə əlavə olunmayıb.',
        'Some payment service periods are unknown and are not added to the known period expenses.',
    ],
    SOURCE_PERIOD_CONFLICT: [
        'Источники расходятся по периоду выплаты. Сумма требует сверки.',
        'Mənbələr ödənişin dövrü barədə fərqlənir. Məbləğ uzlaşdırılmalıdır.',
        'The payment period evidence conflicts and needs reconciliation.',
    ],
    PURCHASES_AS_COST_ASSUMPTION: [
        'Для управленческого расчёта закупки месяца приняты за себестоимость. Данные об остатках товаров не используются.',
        'İdarəetmə hesablamasında ayın alışları maya dəyəri kimi qəbul edilir. Mal qalıqları istifadə edilmir.',
        'Monthly purchases are used as the management cost assumption; inventory balances are not used.',
    ],
    ACTUAL_EXPENSES_CASH_MONTH: [
        'Фактические расходы месяца. Закупки, выплаты собственнику и переводы исключены; начисления повторно не добавляются.',
        'Ayın faktiki xərcləridir. Alışlar, sahibə ödənişlər və köçürmələr çıxılıb; hesablamalar təkrar əlavə edilmir.',
        'Actual monthly expenses exclude procurement, owner payouts and transfers; accruals are not added again.',
    ],
    WITHHELD_FEES_REFERENCE: [
        'Удержанные комиссии показаны справочно. В расходы входят только фактические выплаты по правилу KASSA.',
        'Tutulan komissiyalar arayış üçündür. Xərclərə KASSA qaydası üzrə yalnız faktiki ödənişlər daxildir.',
        'Withheld fees are reference only. Expenses follow actual KASSA payments.',
    ],
    NONCASH_SALES_ADJUSTMENT: [
        'Учётные корректировки продаж показаны отдельно и не увеличивают денежные поступления.',
        'Satışların uçot düzəlişləri ayrıca göstərilir və pul daxilolmalarını artırmır.',
        'Accounting sales adjustments are separate and do not increase cash receipts.',
    ],
    EXPENSE_CLASSIFICATION_UNKNOWN: [
        'Назначение части выплат не подтверждено. Полный итог расходов пока неизвестен.',
        'Bəzi ödənişlərin təyinatı təsdiqlənməyib. Xərclərin tam yekunu hələ məlum deyil.',
        'Some payment classifications are unconfirmed; the complete expense total is unknown.',
    ],
    HISTORICAL_PAID_OVERLAP_UNRESOLVED: [
        'Для исторических начальных оплат нет связи с прежними денежными выплатами. Итог расходов и результат не подтверждены до сверки.',
        'Tarixi ilkin ödənişlərin əvvəlki pul ödənişləri ilə əlaqəsi təsdiqlənməyib. Uzlaşdırılanadək xərclərin yekunu və nəticə təsdiqlənmir.',
        'Historical prior payments are not linked to earlier cash payments. Expense and result totals remain unconfirmed until reconciled.',
    ],
    PERIOD_RECEIPTS_NOT_COHORT: [
        'Денежные поступления за месяц не равны оплате продаж этого месяца и не увеличивают продажи повторно.',
        'Ayın pul daxilolmaları həmin ayın satış ödənişlərinə bərabər deyil və satışları təkrar artırmır.',
        'Period cash receipts are not payments allocated to that month sales and do not add sales again.',
    ],
    CURRENT_BALANCE_NOT_SALES_COHORT: [
        'Общая дебиторка на дату, а не остаток продаж выбранного месяца.',
        'Bu, tarixə olan ümumi debitor borcudur, seçilmiş ayın satış qalığı deyil.',
        'Total receivables as of the date, rather than outstanding sales of the selected month.',
    ],
    ORIGINAL_FEE_UNKNOWN: [
        'Исходная комиссия не подтверждена.',
        'İlkin komissiya təsdiqlənməyib.',
        'The original fee is unconfirmed.',
    ],
    REGISTERED_RESULT_ONLY: [
        'Это разность зарегистрированных продаж, закупок и расходов. Она не является полной прибылью после налогов.',
        'Bu, qeydə alınmış satışlar, alışlar və xərclər arasındakı fərqdir. Vergilərdən sonrakı tam mənfəət deyil.',
        'This is the difference between registered sales, purchases and expenses. It is not complete after-tax profit.',
    ],
    EXPENSE_MONTH_BY_CASH_DATE: [
        'Расходы относятся к месяцу фактической выплаты в Cash, включая выплаты по начислениям.',
        'Xərclər Cash-də faktiki ödəniş ayına aiddir, o cümlədən hesablamalar üzrə ödənişlər.',
        'Expenses follow their actual Cash payment month, including payments against accrued bills.',
    ],
    UNLINKED_EXPENSE_COVERAGE: [
        'Для выплат без связи с начислением нельзя подтвердить полноту учёта.',
        'Hesablama ilə əlaqəsi olmayan ödənişlər üzrə uçotun tamlığı təsdiqlənmir.',
        'Completeness cannot be confirmed for payments without an accrual link.',
    ],
    PROCUREMENT_CASH_EXCLUDED: [
        'Оплата закупок и авансы показаны справочно и не прибавляются к закупкам повторно.',
        'Alış ödənişləri və avanslar arayış üçün göstərilir və alışlara təkrar əlavə edilmir.',
        'Purchase payments and advances are shown for reference and are not added to purchases again.',
    ],
    OWNER_SOURCE_CATEGORY_ONLY: [
        'Известны выплаты по статье источника. Это не подтверждает распределение прибыли.',
        'Mənbə maddəsi üzrə ödənişlər məlumdur. Bu, mənfəətin bölüşdürülməsini təsdiqləmir.',
        'Payments under the source category are known. This does not confirm profit distribution.',
    ],
    CASH_FLOW_NOT_ACCRUAL: [
        'Это денежные выплаты за месяц, а не начисленный расход.',
        'Bu, hesablanmış xərc deyil, ay ərzində pul ödənişidir.',
        'These are cash payments in the month, rather than accrued expense.',
    ],
    REGISTERED_PURCHASES_ONLY: [
        'Подтверждены только зарегистрированные закупки.',
        'Yalnız qeydə alınmış alışlar təsdiqlənib.',
        'Only registered purchases are confirmed.',
    ],
    UNCONFIRMED_PURCHASES: [
        'Есть неподтверждённые закупки.',
        'Təsdiqlənməmiş alışlar var.',
        'Some purchases are not confirmed.',
    ],
    REGISTERED_SALES_ONLY: [
        'Подтверждена только зарегистрированная часть продаж.',
        'Satışların yalnız qeydə alınmış hissəsi təsdiqlənib.',
        'Only registered sales are confirmed.',
    ],
    SALES_COHORT_UNALLOCATED: [
        'Полная разбивка по продажам периода не подтверждена.',
        'Dövrün satışları üzrə tam bölgü təsdiqlənməyib.',
        'The full period-sales allocation is not confirmed.',
    ],
    COGS_SOURCE_MISSING: [
        'Нет подтверждённого источника себестоимости.',
        'Maya dəyərinin təsdiqlənmiş mənbəyi yoxdur.',
        'There is no confirmed cost-of-sales source.',
    ],
    EXPENSE_CLASSIFICATION_INCOMPLETE: [
        'Классификация расходов неполная.',
        'Xərclərin təsnifatı natamamdır.',
        'Expense classification is incomplete.',
    ],
    EXPENSE_GROUPING_UNCLASSIFIED: [
        'Распределение по группам не подтверждено.',
        'Qruplar üzrə bölgü təsdiqlənməyib.',
        'Allocation to groups is not confirmed.',
    ],
    PROFIT_INPUTS_MISSING: [
        'Для расчёта прибыли не хватает подтверждённых данных.',
        'Mənfəəti hesablamaq üçün təsdiqlənmiş məlumatlar çatışmır.',
        'Confirmed inputs are missing for profit calculation.',
    ],
    OWNER_CLASSIFICATION_MISSING: [
        'Изъятия собственника не выделены подтверждённым источником.',
        'Sahibin götürdüyü məbləğ üçün təsdiqlənmiş mənbə yoxdur.',
        'Owner withdrawals have no confirmed classification source.',
    ],
    ACCESS_PARTIAL: [
        'Показана только доступная часть.',
        'Yalnız əlçatan hissə göstərilir.',
        'Only the accessible portion is shown.',
    ],
    HISTORY_UNKNOWN: [
        'История подтверждена не полностью.',
        'Tarixçə tam təsdiqlənməyib.',
        'History is not fully confirmed.',
    ],
    DRAFT_ACCOUNTS: [
        'Есть счета с неподтверждёнными остатками.',
        'Təsdiqlənməmiş qalıqları olan hesablar var.',
        'Some account balances are not confirmed.',
    ],
    UNCONFIRMED_EXPENSES: [
        'Есть неподтверждённые расходы.',
        'Təsdiqlənməmiş xərclər var.',
        'Some expenses are not confirmed.',
    ],
    ORIGINAL_ACCRUAL_UNKNOWN: [
        'Исходная сумма начислений известна не полностью.',
        'İlkin hesablanmış məbləğ tam məlum deyil.',
        'Original accrual amounts are not fully known.',
    ],
    READ_PERMISSION_REQUIRED: [
        'Нет разрешения на чтение этих данных.',
        'Bu məlumatları oxumaq icazəsi yoxdur.',
        'Permission to read this data is missing.',
    ],
};
reasons.PRELEDGER_PAID_SERVICE = reasons.PAID_SERVICE_BEFORE_LEDGER;
const reasonText = (locale, code) => reasons[code]?.[locale === 'ru' ? 0 : locale === 'az' ? 1 : 2] ||
    cashOwnerDashboardText(locale, 'unavailable');
function MetricIcon({ kind }) {
    const paths = {
        sales: 'M5 7h14l1 13H4L5 7Zm3 1V6a4 4 0 0 1 8 0v2',
        cogs: 'M3 7l9-4 9 4-9 4-9-4Zm0 0v10l9 4 9-4V7M12 11v10',
        expenses: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3Zm3 5h6m-6 4h6',
        profit: 'M4 20V4m0 16h17M8 15l4-4 4 2 5-7',
        owner: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 21v-2a7 7 0 0 1 14 0v2',
        receivables: 'M3 7h14m-4-4 4 4-4 4M7 17h14m-4-4 4 4-4 4',
        payables: 'M21 7H7m4-4L7 7l4 4M17 17H3m4-4-4 4 4 4',
        money: 'M3 6h18v15H3V6Zm0 0V3h15v3m-3 6h6v5h-6v-5',
        RECEIVED: 'M12 3v12m-4-4 4 4 4-4M4 15v6h16v-6',
        DUE: 'M12 8v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0',
        BRANCH: 'M4 21V4h16v17M2 21h20M8 8h2m4 0h2M8 12h2m4 0h2M10 21v-5h4v5',
        COUNTERPARTY: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M5 21v-2a7 7 0 0 1 14 0v2',
        CATEGORY: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
        ACCOUNT: 'M3 6h18v15H3V6Zm0 0V3h15v3m-3 6h6v5h-6v-5',
        INVOICE: 'M6 3h9l4 4v14H6V3Zm9 0v5h4M9 12h7m-7 4h7',
        OPERATION: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3Zm3 5h6m-6 4h6',
        UNATTRIBUTED: 'M4 8h16v13H4V8Zm3 0V3h10v5m-7 5a2 2 0 0 1 4 0c0 1-2 1-2 3m0 2h.01',
        SUPPLIERS: 'M3 5h11v12H3V5Zm11 4h4l3 4v4h-7M5 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
    };
    return (_jsx("svg", { className: "cash-owner-icon", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: paths[kind] || 'M4 5h16v14H4V5Zm4 4h8m-8 6h8' }) }));
}
const topKeys = ['sales', 'cogs', 'expenses', 'profit', 'owner'];
const bottomKeys = ['receivables', 'payables', 'money'];
/** Presentation order only. Hidden amounts and names never participate in sorting. */
export function cashOwnerRowsByAmount(rows) {
    // The reconciliation is an equation, not a ranking of monetary amounts.
    if (rows.some(row => row.key === 'SALES_RECONCILIATION_GAP') && rows.every(row => row.nodeKind === 'PAYMENT_STATUS'))
        return [...rows];
    if (rows.length === 2 && (rows[0].key === 'PAID_EXPENSES' && rows[1].key === 'UNPAID_EXPENSES' || rows[0].key === 'SUPPLIERS' && rows[1].key === 'ACCRUED'))
        return [...rows];
    const value = (row) => {
        if (row.state !== 'KNOWN' && row.state !== 'PARTIAL')
            return null;
        return row.amountMinor !== undefined && /^-?\d+$/.test(row.amountMinor)
            ? BigInt(row.amountMinor)
            : null;
    };
    return rows
        .map((row, index) => ({ row, index }))
        .sort((a, b) => {
        const av = value(a.row), bv = value(b.row);
        if (av === null)
            return bv === null ? a.index - b.index : 1;
        if (bv === null)
            return -1;
        return av === bv ? a.index - b.index : av > bv ? -1 : 1;
    })
        .map(item => item.row);
}
function DataIcon({ state }) {
    return (_jsx("svg", { viewBox: "0 0 24 24", width: "18", height: "18", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: state === 'NO_ACCESS' ? (_jsxs(_Fragment, { children: [_jsx("rect", { x: "5", y: "10", width: "14", height: "11", rx: "2" }), _jsx("path", { d: "M8 10V7a4 4 0 0 1 8 0v3m-4 5v2" })] })) : (_jsxs(_Fragment, { children: [_jsx("circle", { cx: "12", cy: "12", r: "9" }), _jsx("path", { d: state === 'PARTIAL'
                        ? 'M12 7v6m0 4h.01'
                        : state === 'UNAVAILABLE'
                            ? 'M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4m0 4h.01'
                            : 'M12 11v6m0-10h.01' })] })) }));
}
export function CashOwnerDashboardView({ client, locale, storeId, authorityKey, refreshKey, businessTimezone, onAccessDenied, }) {
    const t = (key) => cashOwnerDashboardText(locale, key);
    const [month, setMonth] = useState(() => cashBusinessDate(businessTimezone).slice(0, 7));
    const [currency, setCurrency] = useState(''), [retry, setRetry] = useState(0);
    const identity = client.identityKey || client;
    const key = JSON.stringify([storeId, month, currency, authorityKey, refreshKey, retry]);
    const [result, setResult] = useState(null);
    const [failed, setFailed] = useState(false), [loading, setLoading] = useState(true);
    const [details, setDetails] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [detailChanged, setDetailChanged] = useState(false);
    const detailRequests = useRef(new Map());
    const [source, setSource] = useState(null);
    const [info, setInfo] = useState(null);
    const generation = useRef(0), apiRef = useRef(client), denied = useRef(onAccessDenied);
    apiRef.current = client;
    denied.current = onAccessDenied;
    const report = result?.key === key && result.identity === identity ? result.report : null;
    const visibleSource = source?.key === key && source.identity === identity && report ? source.row : null;
    const visibleInfo = info?.key === key && info.identity === identity && report ? info : null;
    const instance = useId();
    useEffect(() => {
        const current = ++generation.current, controller = new AbortController(), api = apiRef.current;
        setResult(null);
        setSource(null);
        setInfo(null);
        setFailed(false);
        setDetails({});
        setExpandedRows({});
        if (!cashPeriodValid(month) || !api.ownerDashboard) {
            setLoading(false);
            return () => controller.abort();
        }
        setLoading(true);
        api
            .ownerDashboard({
            month,
            presentation: 'HIERARCHY_V2',
            ...(api.ownerDashboardDetail ? { view: 'SUMMARY' } : {}),
            ...(storeId ? { storeId } : {}),
            ...(currency ? { currency } : {}),
        }, controller.signal)
            .then(value => {
            if (controller.signal.aborted || current !== generation.current || !api.isCurrent())
                return;
            if (value.month !== month ||
                (value.storeId || '') !== storeId ||
                (currency && value.currency !== currency)) {
                setFailed(true);
                return;
            }
            setResult({ key, identity, report: value });
        })
            .catch(cause => {
            if (controller.signal.aborted || current !== generation.current || !api.isCurrent())
                return;
            const failure = api.failure(cause);
            setResult(null);
            setSource(null);
            setFailed(true);
            if (failure.status === 401 || failure.status === 403)
                denied.current();
        })
            .finally(() => {
            if (!controller.signal.aborted && current === generation.current && api.isCurrent())
                setLoading(false);
        });
        return () => {
            controller.abort();
            detailRequests.current.forEach(request => request.abort());
            detailRequests.current.clear();
            generation.current++;
        };
    }, [key, identity, month, storeId, currency, client]);
    const lazy = report?.detailVersion === 1 && Boolean(client.ownerDashboardDetail);
    const detailState = (branch) => lazy && branch ? details[JSON.stringify(branch)] : undefined;
    function loadDetail(branch) {
        if (!lazy || !report || !client.ownerDashboardDetail || !client.isCurrent())
            return;
        const path = JSON.stringify(branch);
        if (detailRequests.current.has(path) || details[path]?.status === 'loaded')
            return;
        const controller = new AbortController();
        const current = generation.current;
        const revision = report.revision;
        const active = () => !controller.signal.aborted && current === generation.current && client.isCurrent();
        detailRequests.current.set(path, controller);
        setDetailChanged(false);
        setDetails(previous => ({ ...previous, [path]: { status: 'loading' } }));
        client.ownerDashboardDetail({
            month: report.month,
            currency: report.currency,
            storeId: report.storeId,
            detailPath: branch,
            revision,
        }, controller.signal).then(value => {
            if (!active())
                return;
            if (value.revision !== revision) {
                setDetailChanged(true);
                setRetry(n => n + 1);
                return;
            }
            setDetails(previous => ({ ...previous, [path]: { status: 'loaded', row: value.row } }));
        }).catch(cause => {
            if (!active())
                return;
            const failure = client.failure(cause);
            if (failure.status === 401 || failure.status === 403) {
                setResult(null);
                denied.current();
            }
            else if (failure.status === 409 && failure.code === 'CASH_OWNER_REPORT_CHANGED') {
                setDetailChanged(true);
                setRetry(n => n + 1);
            }
            else {
                setDetails(previous => ({ ...previous, [path]: { status: 'failed' } }));
            }
        }).finally(() => {
            if (detailRequests.current.get(path) === controller)
                detailRequests.current.delete(path);
        });
    }
    const detailNotice = (branch) => {
        const state = detailState(branch);
        if (state?.status === 'loading')
            return _jsx("p", { role: "status", children: t('loading') });
        if (state?.status === 'failed')
            return (_jsxs(CashNotice, { tone: "danger", children: [t('failed'), _jsx(CashButton, { onClick: () => loadDetail(branch), children: t('refresh') })] }));
        return null;
    };
    const label = (row, fallback) => {
        if (row.reasons.includes('SALES_MONTH_COHORT') && row.key === 'RECEIVED')
            return t('cohortPaid');
        if (row.reasons.includes('SALES_MONTH_COHORT') && row.key === 'DUE')
            return t('cohortDue');
        if (report?.hierarchyVersion === 1 && fallback === 'owner')
            return locale === 'az' ? 'Təsisçi' : t('ownerShort');
        if (report?.hierarchyVersion === 1 && locale === 'az' && (fallback === 'profit' || row.key === 'REGISTERED_RESULT'))
            return 'Mənfəət';
        if (row.state === 'NO_ACCESS')
            return fallback
                ? t(fallback)
                : row.key && row.key in copy
                    ? t(row.key)
                    : t('noAccess');
        if (row.key === 'CURRENT_RECEIVABLES')
            return `${t('CURRENT_RECEIVABLES')}${row.asOfDate ? ` · ${row.asOfDate}` : ''}`;
        if (row.key === 'REGISTERED_RESULT')
            return t('REGISTERED_RESULT');
        if (fallback === 'owner' && row.reasons.includes('OWNER_SOURCE_CATEGORY_ONLY'))
            return t('ownerSource');
        if (fallback === 'profit' &&
            row.state === 'KNOWN' &&
            row.amountMinor &&
            /^-\d+$/.test(row.amountMinor))
            return t('loss');
        return (((row.nodeKind === 'UNATTRIBUTED' || row.nodeKind === 'PAYMENT_STATUS' || row.key === 'UNALLOCATED_SALES_STATUS' || row.key === 'PERIOD_CASH_RECEIPTS_REFERENCE') && row.key && row.key in copy ? t(row.key) : row.label) ||
            (row.key && row.key in copy ? t(row.key) : fallback ? t(fallback) : t('details')));
    };
    const amount = (row) => {
        if (row.state === 'NO_ACCESS' || row.state === 'UNAVAILABLE')
            return '\u2014';
        return row.amountMinor !== undefined && /^-?\d+$/.test(row.amountMinor)
            ? formatCashMinor(row.amountMinor, report.currency, locale)
            : '\u2014';
    };
    const stateLabel = (row, main) => row.state === 'NO_ACCESS'
        ? t('noAccess')
        : row.state === 'UNAVAILABLE'
            ? t(main === 'profit' ? 'notCalculated' : row.children.length || row.hasChildren ? 'partial' : 'unavailable')
            : row.state === 'PARTIAL'
                ? t(row.key === 'REGISTERED_RESULT'
                    ? 'incompleteCalculation'
                    : row.amountMinor === undefined
                        ? 'partial'
                        : 'incompleteValue')
                : t('confirmed');
    const showInfo = (row, main, branch) => {
        setSource(null);
        setInfo({ key, identity, row, main, branch });
        if (branch && row?.hasReferences)
            loadDetail(branch);
        if (!row && report) {
            for (const metric of [...topKeys, ...bottomKeys]) {
                if (report.metrics[metric].hasReferences)
                    loadDetail([['metric', metric]]);
            }
        }
    };
    const referenceLabel = (row) => row.references?.some(child => child.key === 'CURRENT_RECEIVABLES')
        ? t('CURRENT_RECEIVABLES')
        : row.references?.some(child => child.key === 'HISTORICAL_ACCRUALS')
            ? t('HISTORICAL_ACCRUALS')
            : t('cashReference');
    const metric = (initialRow, path, main, trail = [], reference = false, flat = false, depth = 0, inInformation = false, branch) => {
        const detail = detailState(branch);
        const row = detail?.row ?? initialRow;
        const fullTitle = label(row, main), title = main === 'owner' && report?.hierarchyVersion !== 1 ? t('ownerShort') : fullTitle, id = `${instance}-${path}`;
        const hierarchy = report?.hierarchyVersion === 1;
        const periodOnly = flat || main === 'sales' || main === 'cogs' || main === 'expenses' || main === 'profit';
        const visibleReferences = row.state === 'NO_ACCESS' || hierarchy || periodOnly ? [] : row.references ?? [];
        const rows = row.state === 'NO_ACCESS'
            ? []
            : !hierarchy && row.key === 'REGISTERED_RESULT'
                ? row.children
                : cashOwnerRowsByAmount(!hierarchy && (main === 'sales' || main === 'expenses' || flat)
                    ? cashOwnerFlatRows(row.children)
                    : row.children);
        const infoButton = row.state !== 'KNOWN' || reference || row.reasons.length > 0 ||
            Boolean(hierarchy && (row.references?.length || row.hasReferences)) || Boolean(row.truncated);
        const expandable = row.state !== 'NO_ACCESS' && Boolean(rows.length || row.hasChildren || visibleReferences.length || row.source);
        const Frame = expandable ? 'details' : 'div', Trigger = expandable ? 'summary' : 'div';
        return (_jsxs("div", { className: "cash-owner-row", "data-main": Boolean(main), "data-state": row.state, "data-hierarchy": hierarchy || undefined, "data-depth": Math.min(depth, 3), "data-node-kind": row.state === 'NO_ACCESS' ? undefined : row.nodeKind, children: [_jsxs(Frame, { className: `cash-owner-metric ${main ? 'cash-owner-main' : ''}`, "data-state": row.state, onToggle: lazy && expandable ? event => {
                        if (event.target !== event.currentTarget || !(event.currentTarget instanceof HTMLDetailsElement))
                            return;
                        const open = event.currentTarget.open;
                        setExpandedRows(previous => previous[path] === open ? previous : { ...previous, [path]: open });
                        if (open && branch && initialRow.hasChildren)
                            loadDetail(branch);
                    } : undefined, "data-metric": main || row.key || (row.state === 'NO_ACCESS' ? 'restricted' : row.id), "data-positive": main === 'profit' &&
                        row.key !== 'REGISTERED_RESULT' &&
                        row.state === 'KNOWN' &&
                        row.amountMinor !== undefined &&
                        /^[0-9]+$/.test(row.amountMinor) &&
                        BigInt(row.amountMinor) > 0n, children: [_jsxs(Trigger, { className: "cash-owner-summary", "aria-controls": expandable ? `${id}-content` : undefined, children: [_jsx(MetricIcon, { kind: main || (row.state === 'NO_ACCESS' ? 'restricted' : row.nodeKind === 'PAYMENT_STATUS' ? row.key || 'PAYMENT_STATUS' : row.nodeKind || row.key || (row.children.length ? 'group' : '')) }), _jsx("span", { className: "cash-owner-label", children: _jsx("strong", { children: title }) }), _jsx("span", { className: "cash-owner-amount", "data-long": (row.state === 'KNOWN' || row.state === 'PARTIAL') &&
                                        Boolean(row.amountMinor && row.amountMinor.length > 16), children: amount(row) }), _jsx("span", { className: "cash-owner-indicators", children: expandable && (_jsx("span", { className: "cash-owner-chevron", "aria-hidden": "true", children: "\u2304" })) })] }), expandable && (_jsx("div", { id: `${id}-content`, className: "cash-owner-content", "aria-busy": detail?.status === 'loading' || undefined, children: row.state !== 'NO_ACCESS' && (!lazy || expandedRows[path]) && (_jsxs(_Fragment, { children: [branch && detailNotice(branch), rows.map((child, i) => metric(child, `${path}-${child.state === 'NO_ACCESS' ? `restricted-${i}` : child.id}`, undefined, [...trail, fullTitle], false, flat || main === 'sales' || main === 'expenses', depth + 1, inInformation, branch ? [...branch, ['children', child.id]] : undefined)), Boolean(visibleReferences.length) && (_jsxs("aside", { className: "cash-owner-reference", "aria-label": referenceLabel(row), children: [_jsx("h3", { children: t('referenceShort') }), cashOwnerRowsByAmount(visibleReferences).map((child, i) => metric(child, `${path}-reference-${child.state === 'NO_ACCESS' ? `restricted-${i}` : child.id}`, undefined, [...trail, fullTitle, referenceLabel(row)], true, flat || main === 'sales' || main === 'expenses', depth + 1, inInformation, branch ? [...branch, ['references', child.id]] : undefined))] })), row.source && (_jsxs(CashButton, { className: "cash-owner-source", "aria-label": `${t('source')} \u00b7 ${fullTitle}`, onClick: event => {
                                            event.currentTarget.focus();
                                            if (!inInformation)
                                                setInfo(null);
                                            setSource({ key, identity, row, trail: [...trail, fullTitle] });
                                        }, children: [_jsx(MetricIcon, { kind: "source" }), t('source')] }))] })) }))] }), infoButton && (_jsx("button", { type: "button", className: "cash-owner-state-button", "data-state": row.state, "aria-label": `${stateLabel(row, main)} \u00b7 ${fullTitle}`, onClick: event => {
                        event.currentTarget.focus();
                        showInfo(row, main, branch);
                    }, children: _jsx(DataIcon, { state: row.state }) }))] }, path));
    };
    const information = (initialRow, main, branch) => {
        const detail = detailState(branch);
        const row = detail?.row ?? initialRow;
        const codes = new Set();
        const collect = (item) => {
            if (item.state === 'NO_ACCESS') {
                codes.add('READ_PERMISSION_REQUIRED');
                return;
            }
            item.reasons.forEach(code => codes.add(code));
            item.children.forEach(collect);
            if (report?.hierarchyVersion === 1 || main !== 'sales' && main !== 'cogs' && main !== 'expenses' && main !== 'profit')
                item.references?.forEach(collect);
        };
        collect(row);
        return (_jsxs("section", { className: "cash-owner-information", children: [_jsx("h3", { children: label(row, main) }), _jsx("p", { children: stateLabel(row, main) }), main === 'sales' && report?.hierarchyVersion === 1 && (lazy || row.children.some(child => child.key === 'SALES_RECONCILIATION_GAP')) && _jsx("p", { children: t('cohortFormula') }), main === 'cogs' && _jsx("p", { children: t('purchasesMonth') }), main === 'profit' && (_jsx("p", { children: t(row.key === 'REGISTERED_RESULT' ? 'registeredFormula' : 'afterTax') })), row.key === 'RECEIVED' && (_jsx("p", { children: t(row.reasons.includes('SALES_MONTH_COHORT')
                        ? 'cohortPaidHelp'
                        : row.reasons.includes('PERIOD_RECEIPTS_NOT_COHORT')
                            ? 'periodReceiptsHelp'
                            : 'directHelp') })), row.key === 'REGISTERED_RECEIVABLE_SALES' && _jsx("p", { children: t('creditHelp') }), main === 'expenses' && row.state === 'PARTIAL' && _jsx("p", { children: t('expenseSubset') }), main === 'expenses' && row.state === 'UNAVAILABLE' && (row.children.length > 0 || row.hasChildren) && (_jsx("p", { children: t('confirmedWithoutTotal') })), row.state !== 'NO_ACCESS' && row.truncated && _jsx("p", { children: t('truncated') }), [...codes].map(code => (_jsx("p", { children: reasonText(locale, code) }, code))), lazy && branch && initialRow.hasReferences && detailNotice(branch), report?.hierarchyVersion === 1 && row.state !== 'NO_ACCESS' && Boolean(row.references?.length) && (_jsxs("aside", { className: "cash-owner-reference", "aria-label": t('referenceShort'), children: [_jsx("h3", { children: t('referenceShort') }), _jsx("p", { children: t(main === 'sales' || row.key === 'RECEIVED' || row.key === 'DUE' ? 'salesReferenceNote' : main === 'cogs' ? 'procurementReferenceNote' : 'cashReferenceNote') }), cashOwnerRowsByAmount(row.references).map((child, index) => metric(child, `info-${row.id}-${index}`, undefined, [label(row, main), t('referenceShort')], true, false, 1, true, branch ? [...branch, ['references', child.id]] : undefined))] }))] }, main || row.id));
    };
    const date = (value) => {
        try {
            return new Intl.DateTimeFormat(locale, {
                dateStyle: 'short',
                timeStyle: 'medium',
                timeZone: report?.businessTimezone || businessTimezone,
            }).format(new Date(value));
        }
        catch {
            return value;
        }
    };
    const trapSource = (event) => {
        if (event.key !== 'Tab')
            return;
        const dialog = event.currentTarget.querySelector('dialog');
        const focusable = Array.from(dialog?.querySelectorAll('button:not(:disabled), summary, a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]') ?? []).filter(element => {
            let parent = element.parentElement;
            while (parent && parent !== dialog) {
                if (parent instanceof HTMLDetailsElement && !parent.open && element !== parent.querySelector(':scope > summary'))
                    return false;
                parent = parent.parentElement;
            }
            return !element.closest('[hidden], [inert]');
        });
        const first = focusable[0], last = focusable[focusable.length - 1];
        const atBoundary = event.shiftKey ? document.activeElement === first : document.activeElement === last;
        if (first && last && (atBoundary || !focusable.includes(document.activeElement))) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
        }
    };
    return (_jsxs("section", { className: "cash-owner-dashboard", "aria-label": t('title'), children: [_jsxs("header", { className: "cash-owner-heading", children: [_jsx("h1", { children: t('title') }), _jsx(CashButton, { className: "cash-owner-refresh", "aria-label": t('refresh'), disabled: loading, onClick: () => setRetry(n => n + 1), children: _jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.7", "aria-hidden": "true", children: _jsx("path", { d: "M20 7v5h-5M4 17v-5h5M5 8a8 8 0 0 1 13-3l2 2M4 17l2 2a8 8 0 0 0 13-3" }) }) })] }), _jsxs("div", { className: "cash-owner-filters", children: [_jsx(CashPeriodPicker, { compact: true, value: month, onChange: setMonth, locale: locale, label: t('month') }), report && (_jsxs("label", { className: "cash-owner-currency", children: [_jsx("span", { className: "cash-visually-hidden", children: t('currency') }), _jsx("select", { value: currency || report.currency, onChange: event => setCurrency(event.target.value), children: (report.currencies.length ? report.currencies : [report.currency]).map(unit => (_jsx("option", { children: unit }, unit))) })] })), report && (_jsxs(CashButton, { className: "cash-owner-about", onClick: event => {
                            event.currentTarget.focus();
                            showInfo();
                        }, children: [_jsx(DataIcon, { state: Object.values(report.metrics).some(row => row.state !== 'KNOWN')
                                    ? 'PARTIAL'
                                    : 'KNOWN' }), t(Object.values(report.metrics).some(row => row.state !== 'KNOWN')
                                ? 'partialContext'
                                : 'about')] }))] }), detailChanged && report && _jsx("p", { role: "status", children: t('detailChanged') }), !cashPeriodValid(month) ? (_jsx(CashNotice, { children: t('selectMonth') })) : !report ? (failed ? (_jsxs(CashNotice, { tone: "danger", children: [t('failed'), _jsx(CashButton, { onClick: () => setRetry(n => n + 1), children: t('refresh') })] })) : (_jsx("p", { role: "status", children: loading ? t('loading') : t('unavailable') }))) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "cash-owner-ledger", children: topKeys.map(id => metric(report.metrics[id], id, id, [], false, false, 0, false, [['metric', id]])) }, `${key}:${report.revision}`), _jsxs("section", { className: "cash-owner-bottom", "aria-label": t('today'), children: [_jsx("h2", { children: t('today') }), _jsx("time", { className: "cash-owner-context", dateTime: report.asOf, title: `${report.asOf} ${report.businessTimezone}`, children: date(report.asOf) }), _jsx("div", { className: "cash-owner-ledger", children: bottomKeys.map(id => metric(report.metrics[id], id, id, [], false, false, 0, false, [['metric', id]])) }, `bottom:${key}:${report.revision}`)] })] })), visibleInfo && (_jsx("div", { onKeyDownCapture: trapSource, children: _jsxs(CashDialog, { title: t('about'), closeLabel: t('close'), onClose: () => setInfo(null), children: [_jsx(CashFacts, { rows: [
                                [t('month'), `${report.from} — ${report.to}`],
                                [
                                    t('scope'),
                                    storeId
                                        ? report.stores.find(store => store.id === storeId)?.name || storeId
                                        : t('allStores'),
                                ],
                                [t('currency'), report.currency],
                                [t('asOf'), `${date(report.asOf)} · ${report.businessTimezone}`],
                            ] }), visibleInfo.row
                            ? information(visibleInfo.row, visibleInfo.main, visibleInfo.branch)
                            : [...topKeys, ...bottomKeys].map(main => information(report.metrics[main], main, [['metric', main]]))] }) })), visibleSource?.source && (_jsx("div", { onKeyDownCapture: trapSource, children: _jsxs(CashDialog, { title: `${t('source')} · ${label(visibleSource)}`, closeLabel: t('close'), onClose: () => setSource(null), children: [_jsx("p", { children: visibleSource.source.description }), _jsx(CashFacts, { rows: [
                                [t('source'), t(visibleSource.source.kind)],
                                [t('scope'), source.trail.join(' / ')],
                                [t('reference'), visibleSource.source.id],
                                [
                                    t('sourceDate'),
                                    visibleSource.source.businessDate || visibleSource.source.month || '—',
                                ],
                                [t('currency'), report.currency],
                                [t('amountLabel'), amount(visibleSource)],
                            ] })] }) }))] }));
}
